import SDLoader from '@/shared/components/SDComponentsNewDesign/SDLoader/SDLoader'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import PollResultCard from './PollResultCard/PollResultCard'
import usePollResults from './usePollResults'
import { ResultsColumn, ResultsEmpty, ResultsIntro, ResultsTitle } from './styled-components'

const PollResults = () => {
  const { title, intro, loadingText, emptyText, error, loaderHidden, errorHidden, emptyHidden, cards } =
    usePollResults()

  return (
    <ResultsColumn>
      <ResultsTitle>{title}</ResultsTitle>
      <ResultsIntro>{intro}</ResultsIntro>
      <SDLoader hidden={loaderHidden} text={loadingText} />
      <SDNotification type='negative' hidden={errorHidden} primaryText={error} />
      <ResultsEmpty hidden={emptyHidden}>{emptyText}</ResultsEmpty>
      {cards.map(({ poll, expanded }) => (
        <PollResultCard key={poll.poll_key} poll={poll} expanded={expanded} />
      ))}
    </ResultsColumn>
  )
}

export default PollResults
